import IntercomTracker from 'zoomforth_zfutils/intercom_tracker.js';

let intercomTracker;

const init =  function() {
  intercomTracker = new IntercomTracker();
};

const get = function() {
  if (!intercomTracker) {
    throw new Error('You must call `init` on `intercomTracker` appglobal before calling `get`');
  }
  return intercomTracker;
};

export { init, get };

export default { init, get };
